import { AxiosResponse } from "axios";
import { apiInstance } from "@/store/configureStore";

export const getSurveysListRequest = async () => {
  const response: AxiosResponse = await apiInstance.get("/surveys");

  return response.data;
};
